import { type UserGroup } from '@/features/account/services/User/types'

export const getShoppingForText = (activeGroup: UserGroup | null) =>
  activeGroup ? `${activeGroup.name}, business` : 'personal'
